export const aboutData = {
    title: "Who I am",
    description1: "Hello! My name is Manav Mangukiya. I'm an MERN Stack & Python Developer based in India.",
    description2: "I specialize in building modern, scalable, and high-performance web applications using MERN Stack (MongoDB, Express.js, React.js, Node.js) and Python (Django, FastAPI, Flask). With 4+ years of experience, I deliver clean, efficient, and well-optimized code that ensures seamless functionality and long-term maintainability.",
    image: 2
}